// extracted by mini-css-extract-plugin
export var actions = "_lj-g";
export var benefitCard = "_lj-b";
export var benefitIcon = "_lj-d";
export var benefitLabel = "_lj-f";
export var benefits = "_lj-a";
export var benefitsSection = "_lj-8";
export var bodyText = "_lj-7";
export var closeButton = "_lj-2";
export var content = "_lj-3";
export var eyebrow = "_lj-4";
export var heading = "_lj-5";
export var image = "_lj-i";
export var imagePanel = "_lj-h";
export var modal = "_lj-0";
export var offerCard = "_lj-c";
export var offerIcon = "_lj-e";
export var sectionLabel = "_lj-9";
export var shell = "_lj-1";
export var title = "_lj-6";